import { useLang } from '@/i18n';
import styles from './index.module.scss';
import EfImg from '@elem/ui/ef-img';
import EfSpec from '@elem/ui/ef-spec';

type ItemType = {
    title?: string;
    desc?: string;
    img: [string, string];
};
export default function TheComp() {
    const { t } = useLang('theProduct');

    const items: ItemType[] = [
        {
            title: t('B_item1_title'),
            img: ['https://websiteoss.ecoflow.com/upload/image/1737708110286/2_1.jpg', 'https://websiteoss.ecoflow.com/upload/image/1737708109396/2_1_M.jpg'],
        },
        {
            title: t('B_item2_title'),
            desc: t('B_item2_desc'),
            img: ['https://websiteoss.ecoflow.com/upload/image/1736476202188/2_2.jpg', 'https://websiteoss.ecoflow.com/upload/image/1736481482465/2_2_M.jpg'],
        },
        {
            title: t('B_item3_title'),
            desc: t('B_item3_desc'),
            img: ['https://websiteoss.ecoflow.com/upload/image/1737529274799/2_3.jpg', 'https://websiteoss.ecoflow.com/upload/image/1737529275034/2_3_M.jpg'],
        },
        {
            title: t('B_item4_title'),
            img: ['https://websiteoss.ecoflow.com/upload/image/1737518405046/2_4.jpg', 'https://websiteoss.ecoflow.com/upload/image/1737518404685/2_4_M.jpg'],
        },
        {
            title: t('B_item5_title'),
            desc: t('B_item5_desc'),
            img: ['https://websiteoss.ecoflow.com/upload/image/1736476166168/2_5.jpg', 'https://websiteoss.ecoflow.com/upload/image/1736481481790/2_7_M.jpg'],
        },
        {
            desc: t.rich('B_item6_desc', {
                b: (tx: string) => <span className="b">{tx}</span>,
            }),
            img: ['https://websiteoss.ecoflow.com/upload/image/1736476166355/2_6.jpg', 'https://websiteoss.ecoflow.com/upload/image/1736481500948/2_6_M.jpg'],
        },
        {
            title: t('B_item7_title'),
            desc: t('B_item7_desc'),
            img: ['https://websiteoss.ecoflow.com/upload/image/1736476165735/2_7.jpg', 'https://websiteoss.ecoflow.com/upload/image/1736481482257/2_5_M.jpg'],
        },
    ];

    return (
        <div className={styles.comp}>
            <EfSpec />
            <p className="title">{t('B_title')}</p>
            <ul className="items">
                {items?.map((item: ItemType, k: number) => (
                    <li className={`item item-${k + 1}`} key={k}>
                        <div className="item-img">{<EfImg pc={item.img[0]} h5={item.img[1]} />}</div>
                        <div className="item-info">
                            {item?.title && <p className="item-title">{item.title}</p>}
                            {item?.desc && <p className="item-desc">{item.desc}</p>}
                        </div>
                    </li>
                ))}
            </ul>
            <EfSpec />
        </div>
    );
}
